import { ReviewInsightsFilterInterface } from './review-insights-filter';
import { SortingEnum } from '../../components/locations-skeleton/enums/sorting-enum';

export interface LocationComparisonTableSettings {
  pageSize: number;
  pageIndex: number;
  sortField: SortFields;
  sortDirection: SortingEnum;
}

export interface LocationComparisonFilterInterface extends ReviewInsightsFilterInterface,
    LocationComparisonTableSettings {
}

export enum SortFields {
  BUSSINESS_NAME = 'businessName',
  GX_SCORE = 'gxScore',
  AVG_RATING = 'avgRating',
  AVG_LAST_MONTH = 'avgLastMonth',
  AVG_LAST_YEAR = 'avgLastYear',
  TOTAL_REVIEWS = 'totalReviews',
  TOTAL_THIS_MONTH = 'totalThisMonth',
  TOTAL_LAST_YEAR_THIS_MONTH = 'totalLastYearThisMonth',
}
